import React from "react";

const BGElementDark = ({ className }) => {
  return (
    <svg
      width="144"
      height="144"
      viewBox="0 0 144 144"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <circle cx="72" cy="72" r="47" fill="white" fillOpacity="0.08" />
      <circle
        cx="72"
        cy="72"
        r="71.2632"
        stroke="white"
        strokeOpacity="0.08"
        strokeWidth="1.47368"
      />
    </svg>
  );
};

export default BGElementDark;
